import {
  Alert,
  AlertIcon,
  Avatar,
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  Flex,
  Heading,
  Input,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Wrap,
  WrapItem,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import Navbar from "../../../Components/Navbar";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { Link, useNavigate } from "react-router-dom";
import AdminSidebar from "../../../Components/AdminSidebar";
import { Pagination } from "../../../Components/Pagination";
import { AiOutlineEye } from "react-icons/ai";
import axios from "axios";

const Companies = () => {
  const [companies, setCompanies] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const perPage = 9;

  const fetchCompanies = async () => {
    try {
      const response = await axios.get(
        "https://develop-project-360.onrender.com/getAllCompany"
      );
      setCompanies(response.data);
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  let totalPage = Math.ceil(companies.length / perPage);
  let end = page * perPage;
  let start = end - perPage;

  let filteredCompanies = companies.filter(
    (el) =>
      el.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      el.email?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      el.phone?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      el.aadhar?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  let paginationData = filteredCompanies.slice(start, end);
  const navigate = useNavigate();

  return (
    <Flex>
      <AdminSidebar />
      <Box
        pl={{ base: "none", md: "10" }}
        pt={{ base: "none", md: "10" }}
        w={{ base: "100%", md: "80%" }}
      >
        <Navbar />
        <br />
        <br />
        <Heading size={"md"} textAlign={"start"}>
          Company On-Boarded - {companies.length}
        </Heading>
        <Flex justifyContent={"space-between"}>
          <Breadcrumb
            spacing="8px"
            mt={6}
            mb={6}
            separator={<ChevronRightIcon color="gray.500" />}
          >
            <BreadcrumbItem>
              <BreadcrumbLink href="/admin">Dashboard</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <BreadcrumbLink href="/employees">Companies</BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb>
          <Flex justifyContent={"space-between"} gap={3}>
            <Input
              htmlSize={20}
              width="auto"
              placeholder="Search"
              focusBorderColor="green.400"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <Link to="/onboardingCompany">
              <Button
                bgGradient="linear(to-r, teal.300,  teal.100)"
                _hover={{ bgGradient: "linear(to-r, teal.100,  teal.400)" }}
              >
                On Board Company
              </Button>
            </Link>
          </Flex>
        </Flex>

        <Box>
          <TableContainer>
            <Table variant="simple" colorScheme="green" boxShadow={"md"}>
              <Thead>
                <Tr boxShadow={"md"}>
                  {/* <Th
                    boxShadow={"md"}
                    style={{ textAlign: "center" }}
                    _hover={{ bgGradient: "linear(to-r, teal.100,  teal.400)" }}
                  >
                    View
                  </Th> */}
                  <Th
                    boxShadow={"md"}
                    style={{ textAlign: "center" }}
                    _hover={{ bgGradient: "linear(to-r, teal.100,  teal.400)" }}
                  >
                    Company Name
                  </Th>
                  <Th
                    boxShadow={"md"}
                    style={{ textAlign: "center" }}
                    _hover={{ bgGradient: "linear(to-r, teal.100,  teal.400)" }}
                  >
                    Company ID
                  </Th>
                  <Th
                    boxShadow={"md"}
                    style={{ textAlign: "center" }}
                    _hover={{ bgGradient: "linear(to-r, teal.100,  teal.400)" }}
                  >
                    Domain
                  </Th>
                  <Th
                    boxShadow={"md"}
                    style={{ textAlign: "center" }}
                    _hover={{ bgGradient: "linear(to-r, teal.100,  teal.400)" }}
                  >
                    Email
                  </Th>
                  <Th
                    boxShadow={"md"}
                    style={{ textAlign: "center" }}
                    _hover={{ bgGradient: "linear(to-r, teal.100,  teal.400)" }}
                  >
                    Address
                  </Th>
                  <Th
                    boxShadow={"md"}
                    style={{ textAlign: "center" }}
                    _hover={{ bgGradient: "linear(to-r, teal.100,  teal.400)" }}
                  >
                    City
                  </Th>

                  <Th
                    boxShadow={"md"}
                    style={{ textAlign: "center" }}
                    _hover={{ bgGradient: "linear(to-r, teal.100,  teal.400)" }}
                  >
                    Phone
                  </Th>
                  <Th
                    boxShadow={"md"}
                    style={{ textAlign: "center" }}
                    _hover={{ bgGradient: "linear(to-r, teal.100,  teal.400)" }}
                  >
                    Document Type
                  </Th>
                  <Th
                    boxShadow={"md"}
                    style={{ textAlign: "center" }}
                    _hover={{ bgGradient: "linear(to-r, teal.100,  teal.400)" }}
                  >
                    Aadhar Number
                  </Th>
                </Tr>
              </Thead>

              <Tbody>
                {paginationData.length > 0 ? (
                  paginationData.map((el) => (
                    <Tr key={el._id} boxShadow={"md"}>
                      {/* <Td textAlign="center">
                        <Button
                          onClick={() => navigate(`/companyDetails/${el._id}`)}
                          size={"xs"}
                          _hover={{
                            bgGradient: "linear(to-r, teal.100,  teal.400)",
                          }}
                        >
                          <AiOutlineEye />
                        </Button>
                      </Td> */}
                      {/* <Link to={`/employeedetails/${el._id}`}> */}
                      <Td style={{ textAlign: "center" }}>
                        <Wrap>
                          <WrapItem>
                            <Flex justifyContent={"space-around"} gap={2}>
                              <Box
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                }}
                              >
                                <Avatar
                                  name={el.company_name}
                                  size="sm"
                                  src={`https://develop-project-360.onrender.com/${el.logo.path}`}
                                />

                                <span
                                  style={{
                                    position: "absolute",
                                    bottom: "0px",
                                    right: "-1px",
                                    display: "inline-block",
                                    width: "10px",
                                    height: "10px",
                                    borderRadius: "50%",
                                    // backgroundColor: statusColor,
                                  }}
                                />
                              </Box>
                              <Heading size={"xs"}>
                                <Button
                                  size={"xs"}
                                  style={{
                                    maxWidth: "100%",
                                    width: "120px",
                                  }}
                                  mt={1}
                                  _hover={{
                                    bgGradient:
                                      "linear(to-r, teal.100,  teal.400)",
                                  }}
                                >
                                  {el.company_name}
                                </Button>
                              </Heading>
                            </Flex>
                          </WrapItem>
                        </Wrap>
                      </Td>
                      {/* </Link> */}
                      <Td style={{ textAlign: "center" }}>
                        <Button
                          _hover={{
                            bgGradient: "linear(to-r, teal.100,  teal.400)",
                          }}
                          size={"xs"}
                          style={{ maxWidth: "100%", width: "120px" }}
                        >
                          {el.employee_id}
                        </Button>
                      </Td>
                      <Td style={{ textAlign: "center" }}>
                        <Button
                          _hover={{
                            bgGradient: "linear(to-r, teal.100,  teal.400)",
                          }}
                          size={"xs"}
                          style={{ maxWidth: "100%", width: "120px" }}
                        >
                          {el.domain}
                        </Button>
                      </Td>
                      <Td style={{ textAlign: "center" }}>
                        <Button
                          _hover={{
                            bgGradient: "linear(to-r, teal.100,  teal.400)",
                          }}
                          size={"xs"}
                          style={{ maxWidth: "100%", width: "120px" }}
                        >
                          {el.email}
                        </Button>
                      </Td>
                      <Td style={{ textAlign: "center" }}>
                        <Button
                          _hover={{
                            bgGradient: "linear(to-r, teal.100,  teal.400)",
                          }}
                          size={"xs"}
                          style={{ maxWidth: "100%", width: "120px" }}
                        >
                          {el.address}
                        </Button>
                      </Td>
                      <Td style={{ textAlign: "center" }}>
                        <Button
                          _hover={{
                            bgGradient: "linear(to-r, teal.100,  teal.400)",
                          }}
                          size={"xs"}
                          style={{ maxWidth: "100%", width: "120px" }}
                        >
                          {el.city}
                        </Button>
                      </Td>
                      <Td style={{ textAlign: "center" }}>
                        <Button
                          _hover={{
                            bgGradient: "linear(to-r, teal.100,  teal.400)",
                          }}
                          size={"xs"}
                          style={{ maxWidth: "100%", width: "120px" }}
                        >
                          {el.phone}
                        </Button>
                      </Td>
                      <Td style={{ textAlign: "center" }}>
                        <Button
                          _hover={{
                            bgGradient: "linear(to-r, teal.100,  teal.400)",
                          }}
                          size={"xs"}
                          style={{ maxWidth: "100%", width: "120px" }}
                        >
                          {el.document_type}
                        </Button>
                      </Td>
                      <Td style={{ textAlign: "center" }}>
                        <Button
                          _hover={{
                            bgGradient: "linear(to-r, teal.100,  teal.400)",
                          }}
                          size={"xs"}
                          style={{ maxWidth: "100%", width: "120px" }}
                        >
                          {el.aadhar}
                        </Button>
                      </Td>
                    </Tr>
                  ))
                ) : (
                  <Tr>
                    <Td colSpan="5">
                      <Alert
                        status="info"
                        variant="subtle"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        mt={4}
                      >
                        <AlertIcon boxSize={8} />
                        No Record Found
                      </Alert>
                    </Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </TableContainer>

          <Flex justifyContent={"flex-end"} mt={5}>
            <Pagination page={page} setPage={setPage} totalPage={totalPage} />
          </Flex>
        </Box>
      </Box>
    </Flex>
  );
};

export default Companies;
